import Password from './index'
import LyPassword from './ly-index.vue';
export default [
  {
    path: '/change/password',
    name: 'auth-change-password',
    component: Password
  },
  {
    path: '/ly-change/password',
    name: 'leyou-auth-change-password',
    component:LyPassword,
  },
]
